export const formKeys = {
    attrCategory: 'attributeCategory',
    basicDetails: 'basicDetails',
    logo: 'appLogo',
};
